<template>
    <section class="embroidery_headings pb_0 pt-0">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section_heading_box">
                        <h1
                            class="heading1 section_heading position-relative text-center mb-0"
                        >
                            <span class="bg_secondary_white px_40"
                                >IC Marketing Blog</span
                            >
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "ICMarketingBlog",
    components: {},
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
    }
};
</script>
